import React from "react";
import { LegacyCard, LegacyStack, Text } from "@shopify/polaris";

export function ProductAvailability({
  channels,
}: {
  readonly channels: {
    friendly_name: string;
    shopify_domain: string;
    available: boolean;
  }[];
}): JSX.Element {
  return (
    <LegacyCard sectioned title="Availability">
      {channels.map((item) => {
        const { friendly_name, available, shopify_domain } = item;
        return (
          <LegacyCard.Section key={`${friendly_name}:${available}`}>
            <div>
              <LegacyStack alignment="center" distribution="fillEvenly">
                <LegacyStack.Item>
                  <Text as="h4" fontWeight="bold">
                    {friendly_name}
                  </Text>
                  <Text as="span" tone="subdued">
                    {shopify_domain}
                  </Text>
                </LegacyStack.Item>
                <LegacyStack.Item>
                  <span className={`dot ${available ? "availableDot" : "unavailableDot"}`}>&nbsp;</span>
                </LegacyStack.Item>
              </LegacyStack>
            </div>
          </LegacyCard.Section>
        );
      })}
    </LegacyCard>
  );
}
